import { api } from './api';

/**
 * Régua WIRESEO de hard news, conferida ao vivo no editor.
 *
 * O ponto que justifica existir um serviço em vez de contar caracteres no
 * navegador: o número que importa NÃO é o do título digitado. O tema do site
 * cola um sufixo de marca em toda matéria antes de mandar ao Google — medido no
 * ncnews, `" - NC News"` soma 10 caracteres. Numa amostra de 20 matérias, 18
 * estouravam o teto de 70 por causa dele, e ninguém via, porque na tela o
 * título parecia curto.
 *
 * O sufixo mora no `field_map` do site, no servidor. Contar no cliente
 * repetiria o erro com outra roupa.
 */

export interface VeredictoManchete {
  /** título + sufixo do tema — o que o buscador realmente recebe */
  servido: string;
  chars: number;
  min: number;
  max: number;
  /** teto real do redator: `max` menos o tamanho do sufixo */
  orcamento: number;
  /** 0.0–1.0; a régua exige ≤ 0.15 */
  risco_clickbait: number;
  /** posição da entidade no título (0 = começo); null = não aparece */
  pos_entidade: number | null;
  ok: boolean;
  problemas: string[];
}

export interface VeredictoCapa {
  largura: number;
  minimo: number;
  elegivel_discover: boolean;
}

export interface VeredictoRegua {
  site: string;
  sufixo_do_tema: string;
  manchete: VeredictoManchete;
  /** vazio quando não se informou largura de imagem */
  capa: VeredictoCapa | Record<string, never>;
}

export interface ReguaInput {
  titulo: string;
  entidade?: string | null;
  site?: string | null;
  largura_imagem?: number | null;
}

export const wireseoApi = {
  conferir: (body: ReguaInput) =>
    api.post<VeredictoRegua>('/seo-engine/regua/manchete', body),
};

/** Faixa de folga do título, para a barra do editor. */
export type FolgaTitulo = 'curto' | 'ok' | 'estourado';

export function folgaDoTitulo(v: VeredictoManchete): FolgaTitulo {
  if (v.chars > v.max) return 'estourado';
  if (v.chars < v.min) return 'curto';
  return 'ok';
}

/**
 * Quantos caracteres ainda cabem. Negativo = quantos passaram do teto.
 * Serve para a mensagem "faltam 7" / "passou 3".
 */
export function caracteresRestantes(v: VeredictoManchete): number {
  return v.max - v.chars;
}
